import { render, staticRenderFns } from "./MpSortableMultiV2.vue?vue&type=template&id=f30fa236&scoped=true&"
import script from "./MpSortableMultiV2.vue?vue&type=script&lang=js&"
export * from "./MpSortableMultiV2.vue?vue&type=script&lang=js&"
import style1 from "./MpSortableMultiV2.vue?vue&type=style&index=1&id=f30fa236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30fa236",
  null
  
)

export default component.exports